import { Proration } from "../apis/ersys-public"

export const prorate = (value: number, proration: Proration, shutoff: Boolean) => {
    if(shutoff) {
        return value
    }
    return Math.ceil(value * (proration.cost / 100))
}